/** Unterschrift mit Finger/Maus (sc-sign): liefert ein PNG als Data-URL. Für die Quittung der Barauszahlung. */
import { useEffect, useRef, useState } from "react";
import { Button } from "./Button";

export function SignaturePad({ onChange, label = "Hier unterschreiben lassen (Tablet oder Maus)" }: { onChange: (dataUrl: string | null) => void; label?: string }) {
  const ref = useRef<HTMLCanvasElement>(null);
  const [leer, setLeer] = useState(true);
  const zeichnet = useRef(false);

  useEffect(() => {
    const c = ref.current!;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.clientWidth * ratio;
    c.height = c.clientHeight * ratio;
    const g = c.getContext("2d")!;
    g.scale(ratio, ratio);
    g.lineWidth = 2.2;
    g.lineCap = "round";
    g.lineJoin = "round";
    g.strokeStyle = getComputedStyle(c).color;
  }, []);

  const punkt = (e: React.PointerEvent<HTMLCanvasElement>) => {
    const r = ref.current!.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  };
  const start = (e: React.PointerEvent<HTMLCanvasElement>) => {
    zeichnet.current = true;
    const g = ref.current!.getContext("2d")!;
    const p = punkt(e);
    g.beginPath();
    g.moveTo(p.x, p.y);
    ref.current!.setPointerCapture(e.pointerId);
  };
  const bewegen = (e: React.PointerEvent<HTMLCanvasElement>) => {
    if (!zeichnet.current) return;
    const g = ref.current!.getContext("2d")!;
    const p = punkt(e);
    g.lineTo(p.x, p.y);
    g.stroke();
    if (leer) setLeer(false);
  };
  const ende = () => {
    if (!zeichnet.current) return;
    zeichnet.current = false;
    onChange(ref.current!.toDataURL("image/png"));
  };
  const loeschen = () => {
    const c = ref.current!;
    c.getContext("2d")!.clearRect(0, 0, c.width, c.height);
    setLeer(true);
    onChange(null);
  };

  return (
    <div className="sc-col" style={{ gap: 6 }}>
      <canvas ref={ref} className="sc-sign app-sign" style={{ touchAction: "none", width: "100%", height: 140, cursor: "crosshair" }} onPointerDown={start} onPointerMove={bewegen} onPointerUp={ende} onPointerLeave={ende} aria-label="Unterschriftfeld" role="img" />
      <div className="sc-spread">
        <span className="sc-muted sc-small">{leer ? label : "Unterschrift erfasst"}</span>
        <Button variant="quiet" icon="undo-2" onClick={loeschen} disabled={leer}>Unterschrift löschen</Button>
      </div>
    </div>
  );
}
